export default "__VITE_ASSET__DsET_IqQ__"